import { FormattedMessage } from 'react-intl';

import { RiArrowDownSFill, RiArrowUpSFill } from 'react-icons/ri';

import { Stack, Typography } from '@mui/material';

import { PrivacyContextAwareMoneyValue } from './PrivacyContextAwareMoneyValue';

export interface PortfolioAppreciationProps {
  appreciation: number;
  initialInvestment: number;
}

export const PortfolioAppreciation = ({ appreciation, initialInvestment }: PortfolioAppreciationProps) => {
  const ArrowIndicator = appreciation < 0 ? RiArrowDownSFill : RiArrowUpSFill;
  return (
    <Stack ml={1}>
      <Typography
        variant="inherit"
        component="span"
        fontWeight="semibold"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent={{ base: 'center', lg: 'unset' }}
      >
        <FormattedMessage
          id="portfolio-appreciation-change"
          defaultMessage="{icon} {change} appreciation"
          values={{
            icon: appreciation !== 0 ? <ArrowIndicator fontSize={20} /> : undefined,
            change: <PrivacyContextAwareMoneyValue value={appreciation} length={4} />,
          }}
        />
      </Typography>
      <Typography variant="inherit" component="span" fontWeight="semibold">
        <FormattedMessage
          id="initial-investment"
          defaultMessage="{initialInvestment} Initial Investment"
          values={{
            initialInvestment: (
              <Typography variant="inherit" component="span">
                <PrivacyContextAwareMoneyValue length={5} value={initialInvestment} />
              </Typography>
            ),
          }}
        />
      </Typography>
    </Stack>
  );
};
